import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { styled } from '@mui/material/styles';
import { AlertTitle, Box, Fade, Icon } from '@mui/material';
import CancelOutlined from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineRounded from '@mui/icons-material/CheckCircleOutlineRounded';
import ErrorOutlineRounded from '@mui/icons-material/ErrorOutlineRounded';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded';

function Alert(props) {
  return <MuiAlert elevation={6} {...props} />;
}

const RootBox = styled('div')(({ theme }) => ({
  width: '100%',
  '& > * + *': {
    marginTop: theme.spacing(2)
  }
}));

const SnackBar = (props) => {
  // const [open, setOpen] = React.useState(props.open);

  //   const handleClick = () => {
  //     setOpen(true);
  //   };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    //setOpen(false);
    props.setOpen(false);
  };

  return (
    <RootBox>
      <Snackbar
        open={props.open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={
          props.custom
            ? { vertical: '', horizontal: '' }
            : { vertical: 'top', horizontal: 'center' }
        }
        slots={{
          transition: Fade
        }}
        slotProps={{
          transition: { enter: true }
        }}
      >
        <div>
          {props.custom ? (
            <CustomAlert
              onClose={handleClose}
              severity={props.severity}
              message={props.message}
            />
          ) : (
            <Alert onClose={handleClose} severity={props.severity}>
              {props.message}
            </Alert>
          )}
        </div>
      </Snackbar>
    </RootBox>
  );
};

export default SnackBar;

const CustomAlert = ({ severity, message, handleClose }) => {
  const getIcon = () => {
    switch (severity) {
      case 'success':
        return <CheckCircleOutlineRounded fontSize="inherit" />;
      case 'error':
        return <CancelOutlined fontSize="inherit" />;
      case 'warning':
        return <WarningAmberRounded fontSize="inherit" />;
      case 'info':
        return <InfoOutlined fontSize="inherit" />;
      default:
        return null;
    }
  };

  return (
    <Alert
      onClose={handleClose}
      sx={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 210,
        height: 150,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: 2
      }}
      severity={severity}
      icon={false}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Box sx={{ fontSize: 58 }}>{getIcon()}</Box>
        <AlertTitle>{severity.toUpperCase()}</AlertTitle>
        {message}
      </Box>
    </Alert>
  );
};
